export const HIRE_EMPLOYMENT_TYPES = ['ОсновноеМестоРаботы', 'Совместительство', 'ВнутреннееСовместительство', 'Подработка'] as const
export const HIRE_EMPLOYMENT_LABELS = ['Основное место работы', 'Совместительство', 'Внутреннее совместительство', 'Подработка']
export const HIRE_FIELDS = ['firstName', 'lastName', 'middleName', 'fin', 'documentTypeId', 'documentEffectiveFrom', 'staffPositionId', 'effectiveDate', 'staffUnits', 'employmentType', 'accruals', 'confirmedPhysicalPersonId', 'mainEmployeeId', 'workScheduleId', 'documentSeries', 'documentNumber', 'documentIssueDate', 'documentExpiryDate', 'documentIssuedBy', 'birthDate', 'gender', 'birthPlace', 'taxId', 'comment'] as const
export interface HireInput {
  firstName: string; lastName: string; middleName?: string; fin: string
  documentTypeId: string; documentEffectiveFrom: string; staffPositionId: string; effectiveDate: string
  staffUnits: string; employmentType: typeof HIRE_EMPLOYMENT_TYPES[number]
  accruals: { accrualId: string; amount: string }[]
  confirmedPhysicalPersonId?: string; mainEmployeeId?: string; workScheduleId?: string
  documentSeries?: string; documentNumber?: string; documentIssueDate?: string; documentExpiryDate?: string; documentIssuedBy?: string
  birthDate?: string; gender?: string; birthPlace?: string; taxId?: string; comment?: string
}
export interface HireRef { id: string; name: string; type: string }
export interface HireReferences {
  source: string; companyId: string; headOrganization: HireRef | null
  documentTypes: HireRef[]; staffPositions: HireRef[]; accrualTypes: HireRef[]; workSchedules: HireRef[]
  employmentTypes: string[]; blockers: string[]
  /** Free staff units by lowercase position id; absent when 1C has no approved units for it. */
  staffVacancies?: Record<string, { total: number; free: number }>
}
export interface HireFinResult { state: 'found' | 'not_found' | 'ambiguous'; persons: { id: string; fullName: string; birthDate: string | null }[] }
export function hireMissing(f: Partial<HireInput>, fin?: HireFinResult): string[] {
  const missing: string[] = []
  for (const [key, title] of [['lastName', 'Фамилия'], ['firstName', 'Имя'], ['documentTypeId', 'Вид документа'], ['documentEffectiveFrom', 'Документ действует с'], ['staffPositionId', 'Позиция ШР'], ['effectiveDate', 'Дата приёма']] as const)
    if (!f[key]?.trim()) missing.push(title)
  if (!/^[A-Z0-9]{7}$/.test(f.fin ?? '')) missing.push('ФИН из 7 символов')
  if (!/^\d{1,3}(?:\.\d{1,2})?$/.test(f.staffUnits ?? '') || Number(f.staffUnits) <= 0) missing.push('Количество ставок больше нуля')
  if (!f.accruals?.length || f.accruals.some(a => !a.accrualId || !/^\d{1,12}(?:\.\d{1,2})?$/.test(a.amount))) missing.push('Начисления и суммы')
  if (!fin) missing.push('Проверка ФИН')
  if (fin?.state === 'ambiguous') missing.push('Устранить неоднозначность ФИН в 1С')
  if (fin?.state === 'found' && f.confirmedPhysicalPersonId !== fin.persons[0]?.id) missing.push('Подтверждение найденного физлица')
  if (f.employmentType === 'ВнутреннееСовместительство' && !f.mainEmployeeId) missing.push('Основной сотрудник')
  return missing
}

export interface DirectHireInput {
  requestId: string
  employmentId?: string
  approvedBy: string
  approvedOn: string
  basis: string
  uploadIds?: string[]
}
